import restClient from 'Shared/hooks/restClient'
import waitForDeferredResult from "Shared/utils/waitForDeferredResult"
import SimpleAnalyticsView from './SimpleAnalyticsView'
import { transformChartData } from 'Analytics/utils/transformChartData'
import Loading from 'Shared/components/Loading'
import Button from 'Shared/components/Button'

export default function AnalyticsQuery({
  kind,
  defaultFilterValues = [],
  defaultTimeDimension,
  defaultSegmentDimensions = [],
  filtersEnabled = true
}) {
  const [analyticsQuery, setAnalyticsQuery] = useState(null)
  const [loading, setLoading] = useState(true)
  const [dataLoading, setDataLoading] = useState(false)
  const [filterValues, setFilterValues] = useState(defaultFilterValues)
  const [data, setData] = useState(null)
  const [timeDimension, setTimeDimension] = useState(defaultTimeDimension)
  const [segmentDimensions, setSegmentDimensions] = useState(defaultSegmentDimensions)

  useEffect(() => {
    restClient.get(`/api/analytics/analytics_queries/${kind}`)
      .then(response => {
        setAnalyticsQuery(response.data)
        setFilterValues(response.data.defaultFilters)
        if (typeof defaultTimeDimension === 'undefined') { // Only set if not provided
          setTimeDimension(response.data.defaultTimeDimension)
        }
        setLoading(false)
      })
  }, [kind])

  async function fetchData() {
    setDataLoading(true)
    const finalFilterValues = filtersEnabled ? filterValues : defaultFilterValues
    const result = await restClient.post(`/api/analytics/analytics_queries/run_query`, { kind, filterValues: finalFilterValues, segmentDimensions, timeDimension })
    const deferredResultId = result.data.deferredResultId
    const data = await waitForDeferredResult(deferredResultId)
    setData(data.data)
    setDataLoading(false)
  }

  useEffect(() => {
    if (!loading) {
      fetchData()
    }
  }, [loading])

  if (loading) {
    return <div>Loading...</div>
  }

  if (!analyticsQuery) {
    return <div>No data available</div>
  }

  const { availableFilters } = analyticsQuery
  const chartData = transformChartData({ data, analyticsQuery, segmentDimensions });
  const showData = data && data.length > 0 && !dataLoading

  return (
    <div>
      <div className='margin-bottom'>
        <Button primary onClick={fetchData}>Update stats</Button>
      </div>
      { dataLoading && <Loading /> }
      { !showData && !dataLoading && <p>No data available for the selected filters and segments.</p> }
      { showData && <SimpleAnalyticsView chartData={chartData} /> }
    </div>
  )
}
